export default __webpack_public_path__ + "static/media/poster4.275ba9df.png";